import React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppBar, Card, Tab, Tabs } from '@material-ui/core';
import { ApplicationContext, AppContext } from '../../../../context/Contexts';
import { PartMappingTabEnum } from '../../../../helpers/Constants';
import TabPanel from '../../../_shared/Tabs';
import PartMappingList from './PartMappingList';
import PartMappingTree from './PartMappingTree';

interface IPartMappingsState {
  selectedTab: PartMappingTabEnum;
}

type IPartMappingsProps = RouteComponentProps<{ id: string }>;

class PartMappings extends React.PureComponent<IPartMappingsProps, IPartMappingsState> {
  static contextType = ApplicationContext;

  state = {
    selectedTab: PartMappingTabEnum.List
  } as IPartMappingsState;

  private get organizationId(): number {
    return Number.parseInt(this.props.match.params.id);
  }

  handleTabChange = (selectedTab: PartMappingTabEnum) => {
    this.setState({ selectedTab: selectedTab });
  };

  public render() {
    const { translatorService, organizationService, referentialService } = this
      .context as AppContext;

    return (
      <Card>
        <AppBar position="static" elevation={0} color="secondary">
          <Tabs
            value={this.state.selectedTab}
            onChange={(e: any, newValue: PartMappingTabEnum) => this.handleTabChange(newValue)}
            variant="fullWidth"
            centered={true}
            indicatorColor="primary"
          >
            <Tab label={translatorService.Tranlate('PART_MAPPING_LIST_TAB', 'Listă')} />
            <Tab label={translatorService.Tranlate('PART_MAPPING_HIERARCHY_TAB', 'Ierarhie')} />
          </Tabs>
        </AppBar>
        <TabPanel value={this.state.selectedTab} index={PartMappingTabEnum.List}>
          <PartMappingList {...this.props} />
        </TabPanel>
        <TabPanel value={this.state.selectedTab} index={PartMappingTabEnum.Tree}>
          <PartMappingTree
            organizationId={this.organizationId}
            translatorService={translatorService}
            organizationService={organizationService}
            referentialService={referentialService}
          />
        </TabPanel>
      </Card>
    );
  }
}

export default PartMappings;
